var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'nav-open': _vm.$sidebar.show}},[_c('Notifications'),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }